import React from 'react';
import { useHistory } from 'react-router-dom';
import { PopupContainer } from "components/EditJob/common.styles";
import { CrossButtonBlack } from "components/Buttons/CrossButton";
import DefaultButton from "components/Buttons/DefaultButton";
import { Button } from "@material-ui/core";
import clsx from "clsx";
import styles from "../PostJob.module.scss";
import {exitReact} from "utils";

interface AddPaymentDetailsModalProps {
    setIsOpenPaymentDetailsPopup: (isOpen: boolean) => void;
    locationId: number;
}

export const AddPaymentDetailsModal: React.FC<AddPaymentDetailsModalProps> = ({
    setIsOpenPaymentDetailsPopup,
    locationId
}) => {
    const history = useHistory();

    const handleAddPaymentInfoLater = () => {
        setIsOpenPaymentDetailsPopup(false)
        exitReact('home')
        history.push('loading')
    }

    return (
        <PopupContainer>
            <div className={styles.titleContainer}>
                <div className={styles.popupTitle}>Add Payment Information</div>
                <CrossButtonBlack
                    className={clsx("no-fastclick", styles.crossButtonDark)}
                    onClick={() => {
                        setIsOpenPaymentDetailsPopup(false)
                        exitReact('home')
                        history.push('loading')
                    }}
                />
            </div>

            <div className={styles.description}>
                Great! We'll need payment information before you can view offers for this shift. Would you like to add it now or later?
            </div>

            <div className={styles.shiftIsReadyButtonRow}>
                <DefaultButton
                    variant="contained"
                    size="large"
                    color="primary"
                    onClick={() => {
                        history.push('loading')
                        exitReact('payment-info', {locationId: locationId})
                    }}
                >
                    Add payment info now
                </DefaultButton>
                <Button
                    variant="outlined"
                    color="primary"
                    size="large"
                    id="continue-button"
                    className={clsx(styles.shiftIsReadyButtonRow__button, "no-fastclick")}
                    onClick={handleAddPaymentInfoLater}
                >
                    Add payment info later
                </Button>
            </div>
        </PopupContainer>
    );
};
